module.exports = __webpack_public_path__ + "static/img/organilog-thumb.51f8acd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/organilog-thumb.jpg
// module id = 37
// module chunks = 0